import Vue from 'vue'
import App from './App'
import {focus} from 'vue-focus'
import router from './router'
import './filters'
import './http'

Vue.config.productionTip = false
Vue.config.keyCodes.plus = 107
Vue.config.keyCodes.minus = 109

Vue.directive('focus', focus)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js